import { render, staticRenderFns } from "./r-textarea.vue?vue&type=template&id=6afb36ae&scoped=true"
import script from "./r-textarea.vue?vue&type=script&lang=js"
export * from "./r-textarea.vue?vue&type=script&lang=js"
import style0 from "./r-textarea.vue?vue&type=style&index=0&id=6afb36ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb36ae",
  null
  
)

export default component.exports